import { Link } from "react-router-dom";
import { AppShell } from "../components/AppShell";

export function NotFoundPage() {
  return <AppShell title="Page not found" subtitle="The requested OpsTrack route does not exist."><div className="empty-state"><Link className="button primary" to="/">Return home</Link></div></AppShell>;
}
